export const features = {
feeCategorySpendMapping: true,
programAdjustment: false,
showGraceDaysFilter: false,
copyRebateFromAnyRebate: false,
showHistoricalMonthlyBreakupTab: false,
showProgramLevelAggregateTable: false,
workflowRoleExport: false,
hiddenLinks: [],
hiddenLandingPageOptions: [],
};
